export const UNRECOGNIZED_TOKEN_ERROR = 'Unrecognized token error';
export const SIGN_IN_SUCCESS_MESSAGE = 'Sign in successful';
export const SIGN_UP_SUCCESS_MESSAGE = 'Sign up successful';
export const CONFIRMATION_SENT_MESSAGE =
	'An e-mail has been sent to your address to confirm your account.';
export const SESSION_EXPIRED_ERROR =
	'Your session has expired.\nPlease sign in again.';
